export const SAVE_PREFERENCES_START = 'SAVE_PREFERENCES_START';
export const SAVE_PREFERENCES_SUCCESS = 'SAVE_PREFERENCES_SUCCESS';
export const SAVE_PREFERENCES_ERROR = 'SAVE_PREFERENCES_ERROR';
export const SAVE_PREFERENCES_LOADING = 'SAVE_PREFERENCES_LOADING';
export const SAVE_PREFERENCES_CANCEL = 'SAVE_PREFERENCES_CANCEL';

export type Actions = {
  SAVE_PREFERENCES_START: {
    type: typeof SAVE_PREFERENCES_START;
    payload: any;
  };
  SAVE_PREFERENCES_LOADING: {
    type: typeof SAVE_PREFERENCES_LOADING;
    payload: boolean;
  };
  SAVE_PREFERENCES_SUCCESS: {
    type: typeof SAVE_PREFERENCES_SUCCESS;
    payload: any;
  };
  SAVE_PREFERENCES_ERROR: { 
    type: typeof SAVE_PREFERENCES_ERROR; 
    payload: any;
  };
  SAVE_PREFERENCES_CANCEL: { 
    type: typeof SAVE_PREFERENCES_CANCEL; 
    payload: any;
  };
};
// Action Creators
export const actionCreators = {
  savePreferencesStart: (
    payload: any,
  ): Actions[typeof SAVE_PREFERENCES_START] => ({
    type: SAVE_PREFERENCES_START,
    payload,
  }),
  savePreferencesError: (
    payload: any,
  ): Actions[typeof SAVE_PREFERENCES_ERROR] => ({ 
    type: SAVE_PREFERENCES_ERROR, 
    payload: payload,
  }),
  savePreferencesSuccess: (
    payload: any,
  ): Actions[typeof SAVE_PREFERENCES_SUCCESS] => ({
    type: SAVE_PREFERENCES_SUCCESS,
    payload,
  }),
  savePreferencesLoading: (
    payload: boolean,
  ): Actions[typeof SAVE_PREFERENCES_LOADING] => ({
    type: SAVE_PREFERENCES_LOADING,
    payload,
  }),
  savePreferencesCancel: (
    payload: any
  ): Actions[typeof SAVE_PREFERENCES_CANCEL] => ({
    type: SAVE_PREFERENCES_CANCEL,
    payload,
  }),
};
